// extracted by mini-css-extract-plugin
export default {"textInputLabel":"QR-z","textInput":"RR-z","error":"SR-z","disabled":"TR-z"};